import { Search } from "@/models/search/Search";

/**
 * Plain-text label for a stored search (tags + term), used in reorder lists and aria labels.
 */
export const formatSearchDisplayLabel = (search: Search): string => {
  const term = search.searchTerm?.trim() ?? "";
  const tags = (search.searchTags ?? []).map((tag) => tag.trim()).filter(Boolean);

  if (tags.length === 0 && !term) {
    return "Søgning uden søgeterm";
  }

  const parts = [...tags];
  if (term) {
    parts.push(term);
  }

  return parts.join(" · ");
};
